import { useEffect, useState } from "react";
import { Avatar, Card, LevelBadge } from "@jaiho/ui";
import type { RankingsResponse } from "@jaiho/shared";
import { useAuth } from "../state/AuthContext";
import { getXpRankings } from "../api/endpoints";
import "./RankingsScreen.css";

export function RankingsScreen() {
  const { me } = useAuth();
  const [rankings, setRankings] = useState<RankingsResponse | null>(null);

  useEffect(() => {
    void getXpRankings().then(setRankings);
  }, []);

  return (
    <div className="jaiho-rankings">
      <header className="jaiho-rankings__header">
        <div className="jaiho-rankings__title">Rankings</div>
        <div className="jaiho-rankings__sub">Top players by level and XP.</div>
      </header>

      {!rankings && (
        <div className="jaiho-rankings__list">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="jaiho-skeleton jaiho-rankings__skeleton-row" />
          ))}
        </div>
      )}

      {rankings && rankings.entries.length === 0 && (
        <Card className="jaiho-rankings__empty">
          <div className="jaiho-rankings__empty-title">No rankings yet</div>
          <div className="jaiho-rankings__empty-copy">Claim your daily reward to start earning XP and climb the board.</div>
        </Card>
      )}

      {rankings && rankings.entries.length > 0 && (
        <Card className="jaiho-rankings__list">
          {rankings.entries.map((entry) => (
            <div
              key={entry.userId}
              className={`jaiho-rankings__row${entry.userId === me?.profile.userId ? " jaiho-rankings__row--me" : ""}`}
            >
              <span className="jaiho-rankings__rank">{entry.rank}</span>
              <Avatar name={entry.displayName} src={entry.avatarUrl} size={36} />
              <div className="jaiho-rankings__name-col">
                <div className="jaiho-rankings__name">{entry.displayName}</div>
                <div className="jaiho-rankings__xp">{entry.totalXp.toLocaleString("en-IN")} XP</div>
              </div>
              <LevelBadge level={entry.level} size="sm" />
            </div>
          ))}
        </Card>
      )}

      {rankings?.currentUser && !rankings.entries.some((e) => e.userId === rankings.currentUser?.userId) && (
        <Card className="jaiho-rankings__you">
          <div className="jaiho-rankings__row jaiho-rankings__row--me">
            <span className="jaiho-rankings__rank">{rankings.currentUser.rank}</span>
            <Avatar name={rankings.currentUser.displayName} src={rankings.currentUser.avatarUrl} size={36} />
            <div className="jaiho-rankings__name-col">
              <div className="jaiho-rankings__name">{rankings.currentUser.displayName} (you)</div>
              <div className="jaiho-rankings__xp">{rankings.currentUser.totalXp.toLocaleString("en-IN")} XP</div>
            </div>
            <LevelBadge level={rankings.currentUser.level} size="sm" />
          </div>
        </Card>
      )}
    </div>
  );
}
